import type { Action } from '~/actions'
import type { MarketConfig, ShippingSetting } from '~/types'

export function shippingSettings(state: ShippingSetting[] = [], action: Action): ShippingSetting[] {
	switch (action.type) {
		case 'SHIPPING_SETTINGS_LOAD_SUCCESS':
			return action.payload
		default:
			return state
	}
}

export function markets(state: MarketConfig[] | null = null, action: Action): MarketConfig[] | null {
	switch (action.type) {
		case 'MARKETS_LOAD_SUCCESS':
			return action.payload
		default:
			return state
	}
}
